module.exports = __webpack_public_path__ + "assets/img/ade5-gb-sct.svg";